import { AutoUnsubscribe } from 'src/app/shared/decorators/auto-unsubscribe';
import { MedicalNoteTypeEnum, AssessmentTypeEnum, PermissionEnum, CommunicationDirection, SortOrder } from './../../../../../../../shared/models/enums';
import { CaseService } from 'src/app/core/services/case.service';
import { StakeholderHelperService } from '@secca/core/services/stakeholder-helper.service';
import { CaseStakeholder } from './../../../../../../../shared/models/caseStakeholder';
import { CaseSummaryHelperService } from './../../../../../../../core/services/case-summary-helper.service';
import { CaseSummaryFilter } from 'src/app/shared/models/caseSummaryFilter';
import { Case } from 'src/app/shared/models/case';
import { NoteTypeEnum, CallType } from 'src/app/shared/models/enums';
import { CaseHistoryType, CaseObjectType } from './../../../../../../../shared/enums/case-history-type';
import { CaseSummaryService } from 'src/app/core/services/caseSummary.service';
import { CaseSummary } from './../../../../../../../shared/models/caseSummary';
import { UserDto } from './../../../../../../../shared/models/userDto';
import { CaseHistoryEntry } from '../../../../../../../shared/models/caseHistoryEntry';
import { Component, Input } from '@angular/core';
import { PagingInfo } from '@secca/shared/models/paging-info';
import { ScreeningStateDisplayValueAdapter } from '@secca/shared/enums/screening-states';
import {ChannelType} from '@secca/shared/enums/channelType';
import { StakeholderService } from '@secca/core/services/stakeholder.service';

@AutoUnsubscribe
@Component({
    selector: 'app-case-summary-view',
    templateUrl: './case-summary-view.component.html',
    styleUrls: ['./case-summary-view.component.scss'],
    standalone: false
})
export class CaseSummaryViewComponent {
  @Input()
  set case(newCase: Case) {
    if (newCase) {
      this.summaryCase = newCase;
      this.getCaseSummary();
      this.getStakeholders();
    }
  }

  get case(): Case {
    return this.summaryCase;
  }

  stakeholders: CaseStakeholder[];
  caseSummaryList: CaseHistoryEntry[];
  caseSummaryUser: UserDto[];
  caseSummary: CaseSummary;
  caseSummaryEntities: any;
  caseSummaryFilter: CaseSummaryFilter;
  previousCaseSummaryFilter: CaseSummaryFilter = null;
  summaryCase: Case;
  public smsCreatedByMap: HashTable = {};

  pagingInfo: PagingInfo = {
    pageSize:  50,
    pageIndex: 0,
    sortOrder: SortOrder.desc
  };

  constructor(private caseSummaryService: CaseSummaryService,
              private caseSummaryHelperService: CaseSummaryHelperService,
              private caseService: CaseService,
              private stakeholderHelperService: StakeholderHelperService,
              private stakeholderService: StakeholderService,
              public screeningStateDisplayValueAdapter: ScreeningStateDisplayValueAdapter) {
  }

  get CaseHistoryType() {
    return CaseHistoryType;
  }

  get MedicalNoteTypeEnum() {
    return MedicalNoteTypeEnum;
  }

  get AssessmentTypeEnum() {
    return AssessmentTypeEnum;
  }

  get PermissionEnum() {
    return PermissionEnum;
  }

  get NoteTypeEnum() {
    return NoteTypeEnum;
  }

  get ChannelTypeEnum() {
    return ChannelType;
  }

  get CallType() {
    return CallType;
  }

  get CaseObjectType() {
    return CaseObjectType;
  }

  get CommunicationDirection(){
    return CommunicationDirection;
  }

  private getStakeholders() {
    if (this.stakeholders == null && this.summaryCase && this.summaryCase.id != null) {
      this.caseService.getCaseStakeholdersOnCase(this.summaryCase.id).subscribe(
        result => {
          this.stakeholders = result;
        },
        error => console.log(error)
      );
    }

  }

  paginationChanged(index: number): void {
    this.pagingInfo.pageIndex = index;
    this.getCaseSummary();
  }

  getStakeholderIcon(noteId: number) {
    return this.stakeholderService.getStakeholderIconFullPath(
      this.caseSummaryHelperService.getNoteStakeholderType(this.caseSummaryEntities, noteId)
    );
  }

  getNoteStakeholderName(noteId: number) {
    return this.caseSummaryHelperService.getNoteStakeholderName(this.caseSummaryEntities, noteId);
  }

  isNoteDeleted(noteId: number) {
    return this.getNoteDeletedBy(noteId) !== null;
  }

  private getCaseSummary() {
    this.caseSummaryFilter = new CaseSummaryFilter();
    this.caseSummaryFilter.caseId = this.summaryCase.id;
    this.caseSummaryFilter.pageIndex = this.pagingInfo.pageIndex;
    this.caseSummaryFilter.pageSize = this.pagingInfo.pageSize;
    this.caseSummaryFilter.sortOrder = this.pagingInfo.sortOrder;
    this.caseSummaryService.getCaseSummary(this.case.id, this.caseSummaryFilter).subscribe(
      result => {
        this.caseSummary = result;
        this.caseSummaryUser = this.caseSummary.users;
        this.caseSummaryList = this.caseSummary.caseHistoryList;
        this.caseSummaryEntities = this.caseSummary.entities;
        this.pagingInfo.totalNumber = result.totalNumber;
      },
      error => console.log(error)
    );
  }

  private insertLineBetweenCaseSummaryItems(index: number) {
    return this.caseSummaryHelperService.insertLineBetweenCaseSummaryItems(this.caseSummaryList, index);
  }

  private getUserImage(userId: string) {
    return this.caseSummaryHelperService.getUserImage(this.caseSummaryUser, userId);
  }

  private getUserInitials(userId: string) {
    return this.caseSummaryHelperService.getUserInitials(this.caseSummaryUser, userId);
  }

  private getNoteDescriptionSplited(noteId: number): string[] {
    return this.caseSummaryHelperService.getNoteDescriptionSplited(this.caseSummaryEntities, noteId);
  }

  private getNoteDeletedBy(noteId: number) {
    return this.caseSummaryHelperService.getNoteDeletedBy(this.caseSummaryEntities, noteId);
  }

  private getNoteStakeholderType(noteId: number) {
    return this.caseSummaryHelperService.getNoteStakeholderType(this.caseSummaryEntities, noteId);
  }

  private getNoteType(noteId: number) {
    return this.caseSummaryHelperService.getNoteType(this.caseSummaryEntities, noteId);
  }

  private getNoteCalltype(noteId: number) {
    return this.caseSummaryHelperService.getNoteCallType(this.caseSummaryEntities, noteId);
  }

  private isEdited(entry: CaseHistoryEntry): boolean {
    return this.caseSummaryHelperService.isEdited(this.caseSummaryEntities, entry);
  }

  private isCopied(noteId: number): boolean {
    return this.caseSummaryHelperService.isCopied(this.caseSummaryEntities, noteId);
  }

  private showNoteEntity(caseSummaryType: CaseHistoryType) {
    return this.caseSummaryHelperService.showNoteEntity(caseSummaryType);
  }

}


class SmsReceiverStakeholderInfo {
  type: string;
  icon: string;
  unhandled: boolean;
}

interface HashTable {
  [key: string]: SmsReceiverStakeholderInfo;
}
